<template>
    <el-input :value="cachedValue" type="number" @input="onInput"></el-input>
</template>

<script>
    import Big from 'big.js'

    const wy = new Big('10000')

    export default {
        name: "MoneyInput",
        data() {
            return {
                cachedValue: this.getDisplayValue(this.value)
            }
        },
        props: {
            value: {
                type: String
            },
            displayUnit: {
                type: String,
                default: 'y',
                validator: function (value) {
                    return ['y', 'wy'].indexOf(value) !== -1
                }
            }
        },
        watch: {
            value(newValue) {
                const newCachedValue = this.getDisplayValue(newValue)
                if (!this.cachedValue && !newCachedValue) {
                    return
                } else if (this.cachedValue && newCachedValue) {
                    if (Big(this.cachedValue).eq(Big(newCachedValue))) {
                        return
                    }
                }
                this.cachedValue = newCachedValue
            },
            displayUnit() {
                this.cachedValue = this.getDisplayValue(this.value)
            }
        },
        methods: {
            getDisplayValue(value) {
                if (!value || this.displayUnit === 'y') {
                    return value
                }
                return Big(value).div(wy).toString()
            },
            onInput(newValue) {
                if(newValue){
                    const pointIdx = newValue.indexOf(".")
                    const precise = pointIdx === -1 ? 0 : (newValue.length - pointIdx -1)
                    if(this.displayUnit === 'y' && precise>2 || this.displayUnit === 'wy' && precise>6){
                        return
                    }
                }
                this.cachedValue = newValue
                if (!newValue) {
                    this.$emit('input', null)
                    return
                }
                if (this.displayUnit === 'y') {
                    this.$emit('input', newValue)
                    return
                }
                this.$emit('input', Big(newValue).times(wy).toString())
            }
        }
    }
</script>

<style scoped>

</style>
